// extracted by mini-css-extract-plugin
module.exports = {"accentOrb":"about_accentOrb__lNRKs"};